<template>
  <div id="modalResetPasswordUser" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Resetar Senha</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="updatePassword">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-6">
                <label class="form-label">
                  Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.password.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.password.$model"
                />
                <span
                  v-if="v$.password.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.password.minLength.$invalid"
                  class="invalid-feedback"
                >
                  A senha deve ter pelo menos
                  {{ v$.password.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Confirme a Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.confirmPassword.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.confirmPassword.$model"
                />
                <span
                  v-if="v$.confirmPassword.sameAsPassword.$invalid"
                  class="invalid-feedback"
                >
                  As senhas devem ser idênticas
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Resetar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Resetar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'ResetPasswordUserModal',

  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      password: '',
      confirmPassword: '',
      disableButton: false,
    }
  },

  methods: {
    async updatePassword() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch('updatePassword', {
            userId: this.userId,
            password: this.password,
            confirmPassword: this.confirmPassword,
            reset: true,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      password: {
        required,
        minLength: minLength(6),
      },
      confirmPassword: {
        sameAsPassword: sameAs(this.password),
      },
    }
  },

  mounted() {
    showModal('modalResetPasswordUser')
  },
}
</script>
